<template>
  <header class="flex h-[70px] w-screen justify-center bg-white px-3xl">
    <div class="grid w-[1920px] max-w-[1920px] grid-cols-3 items-center gap-sm">
      <div class="justify-start">
        <RouterLink
          class="flex items-center gap-sm text-black no-underline"
          to="/"
        >
          <avtalat-icon id="kundservice-app" />
          <div>
            <div class="type-heading-sm"
              >Avtalat Kundservice</div
            >
            <EnvironmentBar />
          </div>
        </RouterLink>
      </div>
      <div class="flex">
        <slot></slot>
      </div>
      <div class="flex-column z-50 flex items-center justify-end gap-sm type-body-md">
        <RouterLink class="no-underline" to="/minaarenden" target="_blank">
          <font-awesome-icon
            class="mr-2xs"
            icon="fa-regular fa-folder-open"
          /><span>Mina ärenden</span>
        </RouterLink>
        <NotificationsMenu />
        <UserMenu class="z-50" />
      </div>
    </div>
  </header>
</template>
<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFolderOpen } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import EnvironmentBar from "@/layout/app-header/EnvironmentBar.vue";
import UserMenu from "@/layout/app-header/UserMenu.vue";
import NotificationsMenu from "@/layout/app-header/notifications-menu";

library.add(faFolderOpen);
</script>
